import './MobileContracts.css';

import MobilePrefilledInfo from '../../Desktop/Contracts/PrefilledInfo';

export default MobilePrefilledInfo;
